import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JobCategory } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { Observable } from 'rxjs';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';

@Injectable({
    providedIn: 'root',
})
export class JobCategoryApiService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);
    private readonly httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    delete(tenantId: string, id: string): Observable<object> {
        return this.http.delete(this.serviceUtils.getBaseUrl('JobCategory', tenantId) + `/${id}`);
    }

    save(tenantId: string, jobCategory: JobCategory): Observable<JobCategory> {
        if (!jobCategory.id || jobCategory.id === null)
            return this.http.post<JobCategory>(this.serviceUtils.getBaseUrl('JobCategory', tenantId), jobCategory);
        else return this.http.put<JobCategory>(this.serviceUtils.getBaseUrl('JobCategory', tenantId), jobCategory);
    }

    getAll(tenantId: string, showLoading = true): Observable<JobCategory[]> {
        return this.http.get<JobCategory[]>(this.serviceUtils.getBaseUrl('JobCategory', tenantId), {
            headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
        });
    }

    get(tenantId: string, id: string, showLoading = true): Observable<JobCategory> {
        return this.http.get<JobCategory>(`${this.serviceUtils.getBaseUrl('JobCategory', tenantId)}/${id}`, {
            headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
        });
    }
}
